import { useState } from "react";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
import { httpGet, httpPostWithAuth } from "../../axios/axiosUtils";
import {
  getBussinessData,
  showErrortMessage,
} from "../../shared/helpersMethod";
const usePlaceOrder = () => {
  const [loading, setLoading] = useState(false);
  const [placeOrderError, setPlaceOrderError] = useState<boolean>(false);
  const [placeOrderMessage, setPlaceOrderMessage] = useState<string>("");
  const placeOrderApi = async (orderData: any) => {
    const businessData = getBussinessData();
    var successPlaces = false;
    var paymentLink = "";
    var placeOrderData = {};
    setLoading(true);
    try {
      //@ts-ignore
      const res = await httpPostWithAuth(
        URL_CONSTANTS.get("URL_PLACE_ORDER")!,
        { ...orderData },
        businessData.accessToken
      );
      if (res?.data?.message === "Order is placed successfully") {
        placeOrderData = res?.data;
      }
      if (res?.data?.message === "Get payment Link successfully") {
        placeOrderData = res?.data;
        paymentLink = res?.data?.payment_link;
      }
      if (res.type === "error") {
        setPlaceOrderError(true);
        setPlaceOrderMessage(res.message);
        if (res.data && res.data?.aqsati_error) {
          setPlaceOrderMessage(res.data?.aqsati_error);
        }
      }

      setLoading(false);
      return { placeOrderData, paymentLink };
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
      setPlaceOrderError(true);
      setPlaceOrderMessage("Something went wrong");
    }
  };
  const abandonedCartApi = async (orderData: any) => {
    const businessData = getBussinessData();
    var successPlaces = false;
    var paymentLink = "";
    var placeOrderData = {};
    setLoading(true);
    try {
      //@ts-ignore
      const res = await httpPostWithAuth(
        URL_CONSTANTS.get("URL_Abandoned_ORDER")!,
        { ...orderData },
        businessData.accessToken
      );
      if (res?.data?.message === "Order is placed successfully") {
        placeOrderData = res?.data;
      }
      // if (res?.data?.message === "Get payment Link successfully") {
      //   placeOrderData = res?.data;
      //   paymentLink = res?.data?.payment_link;
      // }
      if (res.type === "error") {
        setPlaceOrderError(true);
        setPlaceOrderMessage(res.message);
        // if (res.data && res.data?.aqsati_error) {
        //   setPlaceOrderMessage(res.data?.aqsati_error);
        // }
      }
      setLoading(false);
      return { placeOrderData, paymentLink };
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
      setPlaceOrderError(true);
      setPlaceOrderMessage("Something went wrong");
    }
  };
  return {
    abandonedCartApi,
    placeOrderApi,
    placeOrderError,
    setPlaceOrderError,
    placeOrderMessage,
    loading,
  };
};
export default usePlaceOrder;
